'use strict';

module.exports = '2.26.0';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch-helper/src/version.js
// module id = 326
// module chunks = 142807904292071